module.exports = __webpack_public_path__ + "img/3.731e1618.svg";